var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSleepingBag(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M9 2H15A5 5 0 0 1 20 7V21A1 1 0 0 1 19 22H7A1 1 0 0 1 6 21V7A5 5 0 0 1 9 2M9 5A2 2 0 0 0 8 7V19H11V5H9M13 5V19H18V7A2 2 0 0 0 16 5H13M14 8H17V10H14V8Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSleepingBag);
export default __webpack_public_path__ + "static/media/sleeping-bag.0ae94a09cbbb6137ba64a3fca09d5107.svg";
export { ForwardRef as ReactComponent };